export const BU = 5
export const device = window.innerWidth < 800 ? 'mobile' : 'desktop'

export const ECOSIGN_STATUS_SEND_CONDITIONS_DONE = 'SEND_CONDITIONS_DONE'
export const ECOSIGN_STATUS_SEND_CONDITIONS_FAIL = 'SEND_CONDITIONS_FAIL'
export const ECOSIGN_STATUS_CONDITIONS_ACCEPTED = 'CONDITIONS_ACCEPTED'
export const ECOSIGN_STATUS_VERIFY_OTP_DONE = 'VERIFY_OTP_DONE'
export const ECOSIGN_STATUS_VERIFY_OTP_FAIL = 'VERIFY_OTP_FAIL'
export const ECOSIGN_STATUS_SEND_CONDITIONS_COPY_FAIL = 'SEND_CONDITIONS_COPY_FAIL'
export const ECOSIGN_STATUS_COMPLETED = 'COMPLETED'

// The customer can accept the conditions (FAIL: the link was sent manually)
export const ECOSIGN_STATUS_ACCEPTABLE_LIST = [
  ECOSIGN_STATUS_SEND_CONDITIONS_DONE,
  ECOSIGN_STATUS_SEND_CONDITIONS_FAIL
]

export const ECOSIGN_STATUS_ACCEPTED_LIST = [
  ECOSIGN_STATUS_CONDITIONS_ACCEPTED,
  ECOSIGN_STATUS_VERIFY_OTP_DONE,
  ECOSIGN_STATUS_VERIFY_OTP_FAIL,
  ECOSIGN_STATUS_SEND_CONDITIONS_COPY_FAIL,
  ECOSIGN_STATUS_COMPLETED
]
